'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAdminPubNubClient = fetchAdminPubNubClient;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _PubNubJS = require('PubNubJS');

var _PubNubJS2 = _interopRequireDefault(_PubNubJS);

var _MessagesClient = require('conversations-core/data/MessagesClient');

var _ChatActions = require('conversations-core/actions/ChatActions');

var _PubNubStatusActions = require('conversations-core/actions/PubNubStatusActions');

var _PubNubPresenceActions = require('conversations-core/actions/PubNubPresenceActions');

var _AdminUIActions = require('conversations-core/actions/AdminUIActions');

var _PubNubMessageTypes = require('conversations-schema/constants/PubNubMessageTypes');

var _strings = require('conversations-core/constants/strings');

var _pubNubHelpers = require('conversations-core/utils/pubNubHelpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function checkForRecipient(client, channel, dispatch) {
  client.hereNow({
    channels: [channel],
    includeUUIDs: false,
    includeState: false
  }, function (status, response) {
    if (response.channels[channel].occupancy <= 1) {
      dispatch((0, _AdminUIActions.setRecipientTimeout)(channel));
    } else {
      dispatch((0, _AdminUIActions.clearRecipientTimeout)(channel));
    }
  });
}

function fetchAdminPubNubClient(store) {
  var dispatch = store.dispatch;

  var _store$getState = store.getState(),
      user = _store$getState.auth.user;

  var uuid = user.get('user_id').toString();
  var isJITA = user.get('roles').includes('JITA');

  dispatch((0, _ChatActions.requestedChatConfig)());
  // pubnub needs to init with the promise that returns the pubnub config
  return (0, _PubNubJS2.default)(function () {
    return (0, _MessagesClient.fetchAdminChatConfig)(uuid).then(function (config) {
      dispatch((0, _ChatActions.receivedChatConfig)(config));
      return (0, _pubNubHelpers.getPubNubConfigArguments)(config, uuid);
    }, function (err) {
      dispatch((0, _ChatActions.requestedChatConfigFailed)(err));
      return _q2.default.reject(err);
    });
  }).then(function (_ref) {
    var client = _ref.client,
        config = _ref.config;

    var channelsToSubscribe = config.channel;
    var lobbyIndex = channelsToSubscribe.indexOf((0, _pubNubHelpers.getLobbyChannel)());

    if (isJITA && lobbyIndex !== -1) {
      channelsToSubscribe.splice(lobbyIndex, 1);
    }

    client.addListener({
      message: function message(_message) {
        var subscribedChannel = _message.subscribedChannel,
            action = _message.message.action;

        if (subscribedChannel.indexOf(_strings.PRIVATE_CHANNEL) > -1 && action === _PubNubMessageTypes.OPEN_CHANNEL) {
          dispatch((0, _ChatActions.recievedPrivateOpenChannel)(_message));
        } else if ((0, _pubNubHelpers.isInternalPubNubCommand)(_message.message)) {
          dispatch((0, _ChatActions.receivedCommandMessage)(_message));
        } else {
          checkForRecipient(client, _message.channel, store.dispatch);
          dispatch((0, _ChatActions.receivedPubNubMessage)(_message));
        }
      },
      presence: function presence(_presence) {
        return dispatch((0, _PubNubPresenceActions.receivedPubNubPresence)(_presence));
      },
      status: function status(_status) {
        return dispatch((0, _PubNubStatusActions.receivedPubNubStatus)(_status));
      }
    }).subscribe({
      channels: channelsToSubscribe,
      withPresence: true
    });
    return client;
  });
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/pubNubClients/AdminPubNubClient.js
// module id = 493
// module chunks = 0